import config from "@/config";
import useDialog from "./useDialog";
import { ModalTransition, TrayMoveDialog } from "@/Components";

const { toggleDialog, forceClose } = useDialog();

export default function useTrayMoveDialog() {
    const toggleTrayMoveDialog = (event, data) => {
        toggleDialog(
            TrayMoveDialog,
            ModalTransition,
            data,
            event,
            config.dialogs.drawers.pinsDialog.zindex,
            true
        );
    };

    return {
        toggleTrayMoveDialog,
        forceClose,
    };
}
